__turbopack_context__.v({
  "accordionSlideOverwrite": "promotionalBanner-module-scss-module__rJSihW__accordionSlideOverwrite",
  "actions": "promotionalBanner-module-scss-module__rJSihW__actions",
  "appIcon": "promotionalBanner-module-scss-module__rJSihW__appIcon",
  "banner": "promotionalBanner-module-scss-module__rJSihW__banner",
  "closeButtonDesktop": "promotionalBanner-module-scss-module__rJSihW__closeButtonDesktop",
  "closeButtonMobile": "promotionalBanner-module-scss-module__rJSihW__closeButtonMobile",
  "content": "promotionalBanner-module-scss-module__rJSihW__content",
  "downloadButton": "promotionalBanner-module-scss-module__rJSihW__downloadButton",
  "downloadButtonTextDesktop": "promotionalBanner-module-scss-module__rJSihW__downloadButtonTextDesktop",
  "downloadButtonTextMobile": "promotionalBanner-module-scss-module__rJSihW__downloadButtonTextMobile",
  "fadeIn": "promotionalBanner-module-scss-module__rJSihW__fadeIn",
  "fadeOut": "promotionalBanner-module-scss-module__rJSihW__fadeOut",
  "scaleIn": "promotionalBanner-module-scss-module__rJSihW__scaleIn",
  "scaleOut": "promotionalBanner-module-scss-module__rJSihW__scaleOut",
  "subtitle": "promotionalBanner-module-scss-module__rJSihW__subtitle",
  "textContent": "promotionalBanner-module-scss-module__rJSihW__textContent",
  "title": "promotionalBanner-module-scss-module__rJSihW__title",
  "zoomIn": "promotionalBanner-module-scss-module__rJSihW__zoomIn",
  "zoomOut": "promotionalBanner-module-scss-module__rJSihW__zoomOut",
});
